import { IconGps } from "./Icons";

function LocationModal({ onAllow, onCancel, onManual, error, loading }) {
  return (
    <div className="modal-overlay">
      <div className="modal-card location-modal">

        <h3 className="icon-row">
          <IconGps size={18} />
          Location Access
        </h3>

        <p className="loc-text">
          Your location helps nearby customers discover your business.
        </p>
        <p className="loc-subtext">
          Used only to match your listing to local searches — never shared.
        </p>

        {error && <p className="loc-error">{error}</p>}

        <div className="loc-actions">
          <button
            className="loc-btn allow"
            onClick={onAllow}
            disabled={loading}
            type="button"
          >
            {loading ? "Fetching location..." : "Allow Location"}
          </button>

          <button
            className="loc-btn cancel"
            onClick={onCancel}
            disabled={loading}
            type="button"
          >
            Cancel
          </button>
        </div>

        <button className="loc-manual-link" onClick={onManual} type="button">
          Enter address manually instead
        </button>

      </div>
    </div>
  );
}

export default LocationModal;
